import { Matrix4, Object3D, Quaternion, Vector3 } from "three";

export function SetObjectMatrix(firstObject: Object3D, matrix: Matrix4): void {
  // matrix.makeShear(0, 0, 0, 0, 0, 0);

  firstObject.applyMatrix4(
    firstObject.matrix
      .clone()
      .makeShear(0, 0, 0, 0, 0, 0)
      .invert()

      .multiply(matrix),
  );
  //   firstObject.updateMatrixWorld(false);
}

export function SetObjectMatrixWorld1(
  firstObject: Object3D,
  matrix: Matrix4,
): void {
  const parentWorldMatrix: Matrix4 = firstObject.parent
    ? firstObject.parent.matrixWorld
    : new Matrix4();

  SetObjectMatrix(firstObject, parentWorldMatrix.clone().invert());
  //   firstObject.updateMatrixWorld(false);
}

export function SetObjectMatrixViaBasis(
  firstObject: Object3D,
  matrix: Matrix4,
): void {
  const pos: Vector3 = new Vector3();
  const rot: Quaternion = new Quaternion();

  pos.setFromMatrixPosition(matrix);
  rot.setFromRotationMatrix(matrix);

  firstObject.position.copy(pos);
  firstObject.quaternion.copy(rot);
}

export function SetObjectMatrixWorld(
  firstObject: Object3D,
  matrix: Matrix4,
): void {
  const parentWorldMatrix: Matrix4 = firstObject.parent
    ? firstObject.parent.matrixWorld.clone()
    : new Matrix4();
  parentWorldMatrix.invert().multiply(matrix);
  SetObjectMatrixViaBasis(firstObject, parentWorldMatrix);
  //   firstObject.updateMatrixWorld(false);
}
